//Handling DialogBox on edge cases as mentioned in -> https://1mgtech.atlassian.net/wiki/spaces/LABS/pages/3412623951/Extra+use+cases
import React from "react"
import { useSelector, useDispatch } from "react-redux"
import loadable from "@loadable/component"
import { getAssetPath, sanitizer } from "@commonUtils"
import { hideConfirmDialog } from "@containers/App/reducer"
import { replaceLabsCart } from "@containers/App/reducer"
import useCartAPI from "@flows/AddToCart/actions"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import css from "./LabSKUHandler.scss"
import PrimaryButton from "@components/Buttons/PrimaryButton/PrimaryButton"
import { DIAGNOSTICS } from "@constants"

const Dialog = loadable(() => import("@components/Dialog/Dialog"))

const alertIcon = getAssetPath("svgs/icons/alert_48px.svg")

function LabsSKUHandler({ successHandler, getFullResponse = false }) {
    const {
        showConfirmDialog,
        heading,
        subHeading,
        primaryCtaLabel,
        secondaryCtaLabel,
        confirmDialogType: type,
        icon,
        sku,
    } = useSelector((state) => state.shellReducer?.confirmDialogConfig)
    const city = useSelector((state) => state.locationsReducer.currentCity)
    const { pageName } = useSelector((state) => state.shellReducer)
    const { initiateCartAction } = useCartAPI()

    const dispatch = useDispatch()
    const mixPanelData = {
        business_unit: DIAGNOSTICS,
        page_name: pageName,
        ...sku?.mixPanelData,
    }

    let primaryAction, secondaryAction
    switch (type) {
        case "different_category":
        case "dual_category":
            primaryAction = function primaryAction() {
                const addToCartGaData = sku?.addToCartGaData ? sku.addToCartGaData : {}
                dispatch(
                    replaceLabsCart(
                        {
                            params: {
                                city,
                                sku_ids: [sku?.id],
                            },
                            mixPanelData,
                        },
                        null,
                        null,
                        addToCartGaData
                    )
                )
                dispatch(hideConfirmDialog())
            }

            secondaryAction = function secondaryAction() {
                dispatch(hideConfirmDialog())
            }

            break

        case "no_lab":
            primaryAction = function primaryAction() {
                dispatch(hideConfirmDialog())
            }

            break

        case "change_city":
            secondaryAction = function secondaryAction() {
                dispatch(hideConfirmDialog())
            }

            break

        case "test_already_exist":
            primaryAction = function primaryAction() {
                dispatch(hideConfirmDialog())
            }

            secondaryAction = function secondaryAction() {
                const payload = {
                    city,
                    response_type: getFullResponse ? "full" : "brief",
                    types: "labs",
                    sku_ids: [
                        {
                            test_id: sku?.id,
                            add_separately: true,
                        },
                    ],
                    sku: sku,
                }
                initiateCartAction("add_labs_cart_item", payload, successHandler)
                dispatch(hideConfirmDialog())
            }

            break

        case "not_available_from_one_lab":
        case "test_limit_reached":
        case "test_not_active":
            primaryAction = function primaryAction() {
                dispatch(hideConfirmDialog())
            }

            break

        default:
            break
    }

    return (
        <Dialog
            isOpen={showConfirmDialog && (primaryAction || secondaryAction)}
            stickyBottomComponent={
                <div className="flex alignCenter justifyEvenly fullWidth">
                    {primaryCtaLabel && primaryAction && (
                        <div className={`${css.primaryButton}  flex justifyCenter col-3`}>
                            <PrimaryButton
                                label={primaryCtaLabel}
                                onClick={() => {
                                    primaryAction()
                                }}
                            />
                        </div>
                    )}
                    {secondaryCtaLabel && secondaryAction && (
                        <div className={` flex justifyCenter col-5`}>
                            <PrimaryButton
                                label={secondaryCtaLabel}
                                onClick={() => {
                                    secondaryAction()
                                }}
                                isOutlined
                            />
                        </div>
                    )}
                </div>
            }
        >
            <div className={`widget-container col-8 marginBoth-8`}>
                <div className={`flexColumn justifyBetween alignCenter textCenter marginTop-8"`}>
                    <div className={`flex`}>
                        <ImageLoader
                            src={icon || alertIcon}
                            alt={"Alert icon"}
                            className={`${css.image} flex justifyCenter alignCenter`}
                        />
                    </div>
                    {heading && <div className={`l2SemiBold`}> {heading}</div>}
                    {subHeading && (
                        <div className={`smallRegular marginTop-8 ${css.textCenter}`}>
                            <span dangerouslySetInnerHTML={{ __html: sanitizer(subHeading) }} />
                        </div>
                    )}
                </div>
            </div>
        </Dialog>
    )
}

export default LabsSKUHandler
